// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3a4_F","col":"styles_col__kmmT7"};